import React from 'react';
import { whyChooseUs } from '../data/mockData';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import * as Icons from 'lucide-react';

const WhyChooseUsSection = ({ onOpenContactForm }) => {
  return (
    <section className="py-24 bg-cream-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-wine-500 mb-3">Why Choose Us</p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-wine-950 mb-4">Trusted Trademark Experts</h2>
          <p className="text-stone-500 leading-relaxed">Expert attorneys delivering reliable USPTO filing and dedicated client support from start to finish.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-10">
          {whyChooseUs.map((item) => {
            const IconComponent = Icons[item.icon];
            return (
              <div key={item.id} className="group bg-white rounded-xl p-8 border border-stone-200 hover:border-gold-400 hover:-translate-y-1 hover:shadow-xl hover:shadow-gold-500/10 transition-all duration-300">
                <div className="w-12 h-12 bg-wine-50 rounded-lg flex items-center justify-center mb-5 group-hover:bg-wine-600 transition-colors duration-300">
                  {IconComponent && <IconComponent className="w-6 h-6 text-wine-600 group-hover:text-white transition-colors duration-300" strokeWidth={1.5} />}
                </div>
                <h3 className="text-xl font-semibold text-wine-950 mb-3">{item.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{item.description}</p>
              </div>
            );
          })}
        </div>

        <div className="text-center">
          <Button data-testid="why-choose-cta" onClick={onOpenContactForm}
            className="bg-wine-600 hover:bg-wine-700 text-white font-medium px-6 transition-all">
            Start Today <ArrowRight className="ml-2 w-4 h-4" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
